"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _artifact = _interopRequireDefault(require("./artifact"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PropertySpatialUnit = /*#__PURE__*/function (_artifact$default) {
  _inherits(PropertySpatialUnit, _artifact$default);

  var _super = _createSuper(PropertySpatialUnit);

  function PropertySpatialUnit(artifact) {
    var _this;

    _classCallCheck(this, PropertySpatialUnit);

    _this = _super.call(this, artifact);
    _this.artifact.type = 'property';
    _this.artifact.subtype = 'spatialUnit';
    return _this;
  }
  /**
   * Returns the Artifact Type (to be used before class initialization)
   * @static
   * @returns {string}
   */


  _createClass(PropertySpatialUnit, [{
    key: "getModifiedDate",

    /**
     * Get Modified Date
     * ISO 8601 date string
     * @returns {"string"}
     */
    value: function getModifiedDate() {
      return this.artifact.details.modifiedDate;
    }
    /**
     * Set Modified Date
     * ISO 8601 date string
     * @param {"string"} modifiedDate
     */

  }, {
    key: "setModifiedDate",
    value: function setModifiedDate(modifiedDate) {
      if (modifiedDate) {
        this.artifact.details.modifiedDate = modifiedDate;
      }
    }
    /**
     * Get Spatial Type
     * @returns {string}
     */

  }, {
    key: "getSpatialType",
    value: function getSpatialType() {
      return this.artifact.details.spatialType;
    }
    /**
     * Set Spatial type
     * @param {string} spatialType
     */

  }, {
    key: "setSpatialType",
    value: function setSpatialType(spatialType) {
      if (spatialType) {
        this.artifact.details.spatialType = spatialType;
      }
    }
    /**
     * Get Spatial Data Type
     * @returns {string}
     */

  }, {
    key: "getSpatialDataType",
    value: function getSpatialDataType() {
      return this.artifact.details.spatialDataType;
    }
    /**
     * Set Spatial Data type
     * @param {string} spatialDataType
     */

  }, {
    key: "setSpatialDataType",
    value: function setSpatialDataType(spatialDataType) {
      if (spatialDataType) {
        this.artifact.details.spatialDataType = spatialDataType;
      }
    }
    /**
     * Get Spatial Data
     * @returns {Object}
     */

  }, {
    key: "getSpatialData",
    value: function getSpatialData() {
      return this.artifact.details.spatialData;
    }
    /**
     * Set Spatial Data
     * @param {Object} spatialData
     */

  }, {
    key: "setSpatialData",
    value: function setSpatialData(spatialData) {
      if (spatialData) {
        this.artifact.details.spatialData = spatialData;
      }
    }
    /**
     * Get Textual Data
     * @returns {string}
     */

  }, {
    key: "getTextualData",
    value: function getTextualData() {
      return this.artifact.details.textualData;
    }
    /**
     * Set Textual Data
     * @param {string} textualData
     */

  }, {
    key: "setTextualData",
    value: function setTextualData(textualData) {
      if (textualData) {
        this.artifact.details.textualData = textualData;
      }
    }
    /**
     * Get Address Data
     * @returns {Object}
     */

  }, {
    key: "getAddressData",
    value: function getAddressData() {
      return this.artifact.details.addressData;
    }
    /**
     * Set Address Data
     * @param {Object} addressData
     */

  }, {
    key: "setAddressData",
    value: function setAddressData(addressData) {
      if (addressData) {
        this.artifact.details.addressData = addressData;
      }
    }
    /**
     * Get Official ID
     * @returns {string}
     */

  }, {
    key: "getOfficialID",
    value: function getOfficialID() {
      return this.artifact.details.officialID;
    }
    /**
     * Set Official ID
     * @param {string} officialID
     */

  }, {
    key: "setOfficialID",
    value: function setOfficialID(officialID) {
      if (officialID) {
        this.artifact.details.officialID = officialID;
      }
    }
    /**
     * Get Parent ID
     * @returns {string}
     */

  }, {
    key: "getParentID",
    value: function getParentID() {
      return this.artifact.details.parentID;
    }
    /**
     * Set Parent ID
     * @param {string} parentID
     */

  }, {
    key: "setParentID",
    value: function setParentID(parentID) {
      if (parentID) {
        this.artifact.details.parentID = parentID;
      }
    }
    /**
     * Get Namespace
     * @returns {*}
     */

  }, {
    key: "getNamespace",
    value: function getNamespace() {
      return this.artifact.details.ns;
    }
    /**
     * Set Namespace
     * @param ns
     */

  }, {
    key: "setNamespace",
    value: function setNamespace(ns) {
      if (ns) {
        this.artifact.details.ns = ns;
      }
    }
    /**
     * Return Attributes
     * @returns {Object}
     */

  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this.artifact.details.attrs;
    }
    /**
     * Set Attributes
     * @param {Object} attrs
     */

  }, {
    key: "setAttributes",
    value: function setAttributes(attrs) {
      if (attrs) {
        this.artifact.details.attrs = {};

        for (var attr in attrs) {
          if (attrs[attr]) {
            this.artifact.details.attrs[attr] = attrs[attr];
          }
        }
      }
    }
  }], [{
    key: "getArtifactType",
    value: function getArtifactType() {
      return 'property';
    }
    /**
     * Return the Artifact Subtype (to be used before class initialization)
     * @returns {string}
     */

  }, {
    key: "getArtifactSubtype",
    value: function getArtifactSubtype() {
      return 'spatialUnit';
    }
  }]);

  return PropertySpatialUnit;
}(_artifact.default);

var _default = PropertySpatialUnit;
exports.default = _default;